import { styled } from "@mui/material";

export const StyledTooltipHeading = styled("p")`
  margin: 0;
  ${(props) => props.theme.wsc.typography.body2bold};
`;

export const StyledTooltipText = styled("p")`
  margin: 0;
  ${(props) => props.theme.wsc.typography.body2};
`;
